module.exports = __webpack_public_path__ + "static/media/loader.ebad16cb.gif";